import { template as template_f794c4045b4e4ba3bd0c0da0b840f754 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_f794c4045b4e4ba3bd0c0da0b840f754(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
